import React from 'react';
import { withTranslation } from 'react-i18next';
import ProcentowyWykres from './procentowy-wykres.webp';
import chart4 from './chart4.png';
import KlienciSlupkowy from './klienci_slupkowy.webp';
import video from './BLU-EVENT.webm';
import WzrostLiczbyKlientowPrzychodow from './wzrost_klientow_przychodow.webp';
import WzrostLiczbyPracownikow from './wzrost_liczby_pracownikow.webp';
import './ProjectDescription.sass';
import IRDetector from '../../components/IRDetector/IRDetector';
import Bh1Low from './images/bh1-low.webp';
import Bh1 from './images/Bh1.webp';
import Bh2Low from './images/bh2-low.webp';
import Bh2 from './images/Bh2.webp';
import Bh3Low from './images/bh3-low.webp';
import Bh3 from './images/Bh3.webp';
import Bh4Low from './images/bh4-low.webp';
import Bh4 from './images/Bh4.webp';


class ProjectDescription extends React.Component {
  #videoRef = React.createRef();

  componentDidMount() {
    const shouldRender = !window.location.hostname.includes(process.env.REACT_APP_SUBDOMAIN);
    if (!shouldRender) return;

    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };

    let observer = new IntersectionObserver(this.#runVideoWhenVisible, options);
    observer.observe(this.#videoRef.current);
  }

  render() {
    const { t } = this.props;
    return (
      <div>
      <div>
        <h3>{t("infoAbout")} BluHolding</h3>
      </div>
      <div>
        <p>{t("content1par2")}</p>
        <p>{t("content1par3")}</p>
        <p>{t("content1par4")}</p>
        <p>{t("content1par5")}</p>
      </div>
      <div className="overflow-container">
        <h3>BluHolding {t("inNumbers")}</h3>
        {/*<table className="w100">
        <thead>
          <tr>
          <th>BluHolding</th>
          <th>I 2022</th>
          <th>II 2022</th>
          <th>III 2022</th>
          <th>IV 2022</th>
          <th>I 2023</th>
          <th>II 2023</th>
          </tr>
        </thead>
        <tbody>
          <tr>
          <td>Liczba klientów</td>
          <td>1325</td>
          <td>1219</td>
          <td>952</td>
          <td>876</td>
          <td>1030</td>
          <td>1568</td>
          </tr>
          <tr>
          <td>Wzrost pracowników</td>
          <td>35</td>
          <td>38</td>
          <td>54</td>
          <td>55</td>
          <td>69</td>
          <td>61</td>
          </tr>
          <tr>
          <td>Przychód PLN</td>
          <td>974 238,92</td>
          <td>2 263 851,91</td>
          <td>3 390 892,59</td>
          <td>5 372 597,26</td>
          <td>1 903 006,41</td>
          <td>3 638 813,18</td>
          </tr>
        </tbody>
    </table>*/}
      </div>
      <div className="charts">
        {/* <img src={KlienciSlupkowy} alt="Przyrost klientów" className="w100" />
        <img className="w100" src={ProcentowyWykres} alt="Wykres z danymi z tabeli" />
        <img src={WzrostLiczbyKlientowPrzychodow} alt="Wzrost liczby klientów i przychodów" className="w100" />
        <img src={WzrostLiczbyPracownikow} alt="Wzrost liczby pracowników" className="w100" />
        <img src={chart4} alt="fakty finansowe" className="w100 kolowy" /> */}
        <img 
          src={Bh1Low} srcSet={`${Bh1} 1x`}
          alt="Opis obrazka" loading="lazy" 
          style={{ filter: 'blur(50px)'}} 
          onLoad={e => {
            e.target.style.filter = 'blur(0px)';}}
        />
        <img
          src={Bh4Low} srcSet={`${Bh4} 1x`}
          alt="Opis obrazka" loading="lazy" 
          style={{ filter: 'blur(50px)'}} 
          onLoad={e => {
            e.target.style.filter = 'blur(0px)';}}
        />
        <img 
          src={Bh2Low} srcSet={`${Bh2} 1x`}
          alt="Opis obrazka" loading="lazy" 
          style={{ filter: 'blur(50px)'}} 
          onLoad={e => {
            e.target.style.filter = 'blur(0px)';}}
        />
        <img
          src={Bh3Low} srcSet={`${Bh3} 1x`}
          alt="Opis obrazka" loading="lazy" 
          style={{ filter: 'blur(50px)'}} 
          onLoad={e => {
            e.target.style.filter = 'blur(0px)';}}
        />
        <IRDetector>
        <video ref={this.#videoRef} muted={true} className="w100" src={video} controls={true}></video>
        </IRDetector>
      </div>
      </div>
    );
  }

  #runVideoWhenVisible = (entries, observer) => {
    entries.forEach(entry => {
      if (1) {
        if (entry.isIntersecting) {
          entry.target.play();
        }
        else {
          entry.target.pause();
        }
      }
    });
  }
}

export default withTranslation()(ProjectDescription);